import Store from "App/Store.js";

export default items => Store.dispatch({type: "basketAdd", items});
